import React, { FC, Children, cloneElement } from 'react';
import cn from 'classnames';

import { DEFAULT_THEME, FILE_TYPES } from './config';
import { ICONS } from './icons';
import { TFileLink } from './models';

export const FileLink: FC<TFileLink> = ({
    Text,
    children,
    fileSize,
    fileType,
    marginBottom = true,
    styles,
    className,
    theme = DEFAULT_THEME,
    convertBytes,
}) => {
    let [link] = Children.toArray(children);

    const isFileTypeExist = fileType && FILE_TYPES.includes(fileType);

    if (fileType && isFileTypeExist && React.isValidElement<any>(link)) {
        const icon = ICONS[fileType];
        const key = `key-${fileType}`;

        const Icon = (
            <span key={key} className={styles.icon}>
                {icon}
            </span>
        );

        const {
            props: linkProps,
            props: { children: linkChildren },
        } = link;

        // add to <Link> - element <Icon> to children
        link = cloneElement(link, linkProps, [Icon, ...Children.toArray(linkChildren)]);
    }

    const convertedSize = typeof fileSize === 'string' ? fileSize : convertBytes(fileSize);

    const wrapClassName = cn(className, {
        [styles.wrap]: isFileTypeExist,
        [styles.wrapMargin]: marginBottom,
    });

    return (
        <div className={wrapClassName}>
            <Text marginBottom={false} marginTop={false} theme={theme}>
                {link}
            </Text>
            {convertedSize && (
                <Text kind="caption" marginTop={false} size="s" theme={theme}>
                    {convertedSize}
                </Text>
            )}
        </div>
    );
};
